import * as React from 'react';

import type { IconProps } from './types';

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" />;

export const Filters = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M558.742 46.801c-24.237 0-43.886 19.648-43.886 43.886v49.828H43.886C19.649 140.515 0 160.163 0 184.401c0 24.237 19.648 43.886 43.886 43.886h470.97v49.714c0 24.237 19.648 43.886 43.886 43.886 24.237 0 43.886-19.648 43.886-43.886V90.687c0-24.237-19.648-43.886-43.886-43.886zm187.315 93.714c-24.237 0-43.886 19.648-43.886 43.886 0 24.237 19.648 43.886 43.886 43.886h234.057c24.237 0 43.886-19.648 43.886-43.886 0-24.237-19.648-43.886-43.886-43.886zM465.142 374.571c-24.237 0-43.886 19.648-43.886 43.886v187.2c0 24.237 19.648 43.886 43.886 43.886 24.237 0 43.886-19.648 43.886-43.886v-49.714h471.084c24.237 0 43.886-19.648 43.886-43.886 0-24.237-19.648-43.886-43.886-43.886H509.028v-49.714c0-24.237-19.648-43.886-43.886-43.886zm-421.254 93.6c-24.237 0-43.886 19.648-43.886 43.886 0 24.237 19.648 43.886 43.886 43.886h234.057c24.237 0 43.886-19.648 43.886-43.886 0-24.237-19.648-43.886-43.886-43.886zm514.854 234.057c-24.237 0-43.886 19.648-43.886 43.886v49.714H43.886C19.649 795.828 0 815.476 0 839.714 0 863.951 19.648 883.6 43.886 883.6h470.97v49.714c0 24.237 19.648 43.886 43.886 43.886 24.237 0 43.886-19.648 43.886-43.886v-187.2c0-24.237-19.648-43.886-43.886-43.886zm187.315 93.599c-24.237 0-43.886 19.648-43.886 43.886 0 24.237 19.648 43.886 43.886 43.886h234.057c24.237 0 43.886-19.648 43.886-43.886 0-24.237-19.648-43.886-43.886-43.886z"
        fill={color}
      />
    </svg>
  )
);

export default Filters;
